var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page8-mobile"},[_c('s-swiper',{attrs:{"data-list":_vm.dataList,"title":{
      text: '外观精美',
      color: _vm.colorLabel,
    },"fit":"contain"},on:{"change":_vm.swiperChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }